// react
import React, { Suspense } from "react";

// components
import Spinner from "../../../components/Spinner/ComponentLoader";

// load in the goal tree
const LazyAddSubjects = React.lazy(() => import("./AddSubjects"));

const AddSubjectsLazyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<LazyAddSubjects />
	</Suspense>
);

export default AddSubjectsLazyLoader;
